import React from "react";
import { Link } from "react-router-dom";
import PageSEO from "../components/SEO";
import useContent from "../lib/content";

/**
 * Fase 4 · CMS — página pública "Condiciones de envío". El contenido lo
 * gestiona el admin desde /admin/settings/content (page_key=shipping_terms).
 */
export default function ShippingTermsPage() {
  const { fields } = useContent("shipping_terms");
  const paragraphs = String(fields.body_md || "")
    .split(/\n{2,}/)
    .map((p) => p.trim())
    .filter(Boolean);

  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-8 sm:py-14">
      <PageSEO
        title={fields.seo_title || "Condiciones de envío"}
        description={fields.seo_description}
        canonical="https://mercago.one/condiciones-envio"
      />
      <nav className="text-xs text-neutral-500 mb-4">
        <Link to="/" className="hover:underline">
          Inicio
        </Link>{" "}
        · Condiciones de envío
      </nav>
      <h1
        data-testid="shipping-terms-title"
        className="text-4xl sm:text-5xl font-black tracking-tight"
      >
        {fields.title || "Condiciones de envío"}
      </h1>
      <div
        data-testid="shipping-terms-body"
        className="mt-6 space-y-4 text-neutral-700 leading-relaxed"
      >
        {paragraphs.length === 0 ? (
          <p className="text-neutral-500 italic">
            Estamos preparando esta sección.
          </p>
        ) : (
          paragraphs.map((p, i) => <p key={i}>{p}</p>)
        )}
      </div>
    </div>
  );
}
